import { SET_AADHAR, SET_BENEFICIARY_AUTH_TYPE,VERIFY_CHILD_FROM_GRID,SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY,SET_IS_FIRST_PREGNANCY,UPDATE_FACILITY_SERVICE_DATA,SET_IS_PREGNANT,SET_IS_HRP,SET_CHECK_IS_HRP,SET_CONSENT_LANGUAGE, SET_BENEFICIARY_DATA,SET_SHOW_PREGNANCY, SET_SHOW_SERVICES,SET_ANC_VISIT_DATE, SET_IS_VIEW_BUTTON_CLICKED, SET_BENEFICIARY_GENDER, SET_BENEFICIARY_MOBILE_NUMBER, SET_BENEFICIARY_REDG_OPTION, SET_TSNID, beneficiaryActionType, SET_BENEFICIARY_ABHA, SET_SHOW_CLOSE_MODAL, SET_IS_BENEFICIARY_MODIFIED, UPDATE_CHILD, SET_BENEFICIARY_DETAILS, SET_IMAGE_EDITED, SET_IMAGE_DATA, UPDATE_ANCSERVICE, SET_ANC_NUMBER, SET_FACILITY_DETAILS, SET_PREGNANCY_ID, SET_DIFF_IN_WEEKS, SET_LMP_DATE, UPDATE_PREG_HANDLER, UPDATE_FAMILY_PLANNING_BACK_HANDLER, UPDATE_DELIVERY_DETAILS, SET_FAMILY_PLANNING_DETAILS, SET_SHOW_PREGNANCY_ONGOING,UPDATE_PNC, SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID,UPDATE_FACILITY_META_DATA, SET_BENF_DEATH_DETAILS, UPDATE_CHILD_DETAILS, SET_BENEFICIARY_ALREADY_IN_RCH, SET_BENEFICIARIES_IN_RCH, SET_TXNID_FOR_ABHA_ADDRESS, SET_ABHA_ADDRESS, SET_PRIMARY_NO_FOR_RCH, SET_REFERRAL_MODULE, SET_LIFE_CALENDAR_PAGE_MENU, SET_PREGNANCY_HISTORY, SET_BENEFICIARY_PREGNANCY_HISTORY, SET_BENEFICIARY_IMAGE, SET_HRP_STATUS, SET_PREGNANCY_DETAILS, SET_CHILD_BENEF_LIST, SET_BENEFICIARY_OBSTETRIC_HISTORY } from "@store/types/beneficiaryTypes";

export interface BeneficiaryState {
    beneficiaryGender: any,
    beneficiaryRedgeOption: any,
    beneficiaryAuthType: any,
    beneficiaryMobileNumber: any,
    beneficiaryAlreadyInRCH: any,
    beneficiariesInRCH: any,
    tsnId: any,
    txnIdForAbhaAddress: any,
    abhaAddress: any,
    primaryNoForRCH: any,
    aadhar: string,
    beneficiaryData: any
    abha: string,
    vaccineDateUpdated:boolean,
    createSubmitClicked: boolean,
    verifySubmitClicked: boolean,
    file: File | null,
    isBneficaryChild:boolean,
    childModalImageFile: any,
    parentAbha: string,
    childToken: string,
    childBALAbhaId: string,
    showCloseModal: any,
    isBeneficiaryModified: any,
    regChildDetails: any,
    verifiedChildDetails: any,
    childBALABHAIds: any,
    childId: any,
    beneficiaryDetails: any,
    isImageEdited: any,
    imageData: any,
    showAncModal: boolean,
    currServiceSubCtgryId: any,
    ancNumber: number,
    ancVisitDate: string,
    facilityDetails: any,
    pregnancyId: string,
    diffInWeeks: number,
    lmpDate: string,
    isViewButtonClicked: boolean,
    onSameDay: boolean,
    currPregnancyId: string,
    ancPregnancyBackhandler: any,
    selectedAncService: any,
    viewEditMetaData: any,
    viewAndEditFacilityDetails: any,
    viewPregnancyDetails: any,
    currentFacilityDetails: any,
    isEditButtonClicked: boolean,
    childImageData: File | null,
    serviceCtgryId: any,
    familyPlanningBackHandler: any,
    familyPlanningDetails: any,
    familyPlanningDetailsByTransactionId:any,
    isMotherAlive: boolean,
    currBenfAbhaId: string,
    clickedBtnName: string,
    deliveryVisitDate: string,
    showPregnancy:boolean,
    showServices:boolean,
    pregnancyOngoing:boolean,
    isPNCFirstVisit: boolean,
    isHRP:boolean,
    pncOnSameDay: boolean,
    checkIsHRP:boolean,
    currLmpDate: string,
    childFlow:string,
    verifyChildFromGridData:any,
    updateChildVerifyFromView:boolean,
    isPregnant:boolean,
    benfDeathDetails:any,
    facilityServiceData:any,
    deliveryDate:any,
    isFirstPregnancy:boolean,
    consentLanguageID:any,
    beneficiarySelected:boolean,
    facilityReferralMetaData: any,
    currChildDOB:any,
    childVerifyFromGrid:boolean,
    childBenfId: string,
    currentChildId:any,
    selectedChildServices: any,
    childDetails:any,
    isHBNCSameDay: boolean,
    isHBYCSameDay: boolean,
    isChild: boolean,
    currentChildServiceId: any,
    moduleCode: any,
    pregHistoryDetails:any,
    isPregnancyClosed: boolean,
    canEditANCService:boolean,
    pregnancyServices:any,
    pregnancyHistory:any,
    throughParentProfile: boolean,
    throughReferralModule: boolean,
    childKYCDetails: any,
    childBalAbha: string,
    isNewBornSameDay:boolean,
    sickChildCareVisitDate: any,
    serviceExists: boolean,
    pageMenuFromLifeCalendar: any
    childConsentIds: any,
    isChildRegistration: boolean,
    childRegistrationId: any,
    isKYCVerified: boolean,
    isKYCLoading: boolean,
    imageUrl:any,
    beneficiaryUpdateDetails: any,
    beneficiaryPregnancyHistory:any,
    pregnancyDetails:any,
    hrpStatus:any,
    beneficiaryImage:any,
    childBenefList:any,
    pageForPreviousPregnancyFromLifeCalendar: any,
    isFaceAuthenticated: boolean,
    beneficiaryObstetricHistory:any,
};

export const initialState: BeneficiaryState = {
    beneficiaryGender: '',
    beneficiaryRedgeOption: '',
    beneficiaryAuthType: '',
    beneficiaryMobileNumber: '',
    beneficiaryAlreadyInRCH: '',
    beneficiariesInRCH: '',
    tsnId: '',
    txnIdForAbhaAddress: '',
    abhaAddress: '',
    primaryNoForRCH: '',
    canEditANCService:false,
    aadhar: '',
    beneficiaryData: [],
    abha: '',
    createSubmitClicked: false,
    verifySubmitClicked: false,
    file: null,
    childModalImageFile: null,
    parentAbha: '',
    childToken: '',
    childBALAbhaId: '',
    showCloseModal: false,
    isBeneficiaryModified: false,
    regChildDetails: {},
    verifiedChildDetails: {},
    verifyChildFromGridData:{},
    vaccineDateUpdated:false,
    updateChildVerifyFromView:false,
    childBALABHAIds: [],
    childId: '',
    beneficiaryDetails: [],
    isImageEdited: false,
    imageData: '',
    childFlow:'',
    showAncModal: false,
    currServiceSubCtgryId: '',
    ancNumber: 0,
    beneficiarySelected:false,
    ancVisitDate: '',
    isBneficaryChild:false,
    facilityDetails: {},
    pregnancyId: '',
    diffInWeeks: 0,
    lmpDate: '',
    benfDeathDetails:{},
    isViewButtonClicked: false,
    onSameDay: false,
    currPregnancyId: '',
    ancPregnancyBackhandler: null,
    selectedAncService: [],
    viewEditMetaData: {},
    viewAndEditFacilityDetails: {},
    viewPregnancyDetails: {},
    currentFacilityDetails: {},
    isEditButtonClicked: false,
    childVerifyFromGrid:false,
    isPregnant:false,
    childImageData: null,
    serviceCtgryId: '',
    familyPlanningBackHandler: null,
    familyPlanningDetails: [],
    familyPlanningDetailsByTransactionId:[],
    isMotherAlive: true,
    currBenfAbhaId: '',
    isHRP:false,
    clickedBtnName: '',
    deliveryVisitDate: '',
    showPregnancy:false,
    showServices:false,
    pregnancyOngoing:false,
    isPNCFirstVisit: false,
    facilityServiceData:[],
    pncOnSameDay:false,
    isFirstPregnancy:false,
    checkIsHRP:false,
    currLmpDate: '',
    deliveryDate:'',
    consentLanguageID:[],
    facilityReferralMetaData: {},
    currChildDOB:'',
    childBenfId: '',
    currentChildId: '',
    selectedChildServices: [],
    childDetails:null,
    isHBNCSameDay: false,
    isHBYCSameDay: false,
    isNewBornSameDay:false,
    sickChildCareVisitDate: null,
    isChild:false,
    currentChildServiceId: null,  
    moduleCode: '',
    pregHistoryDetails: {},
    isPregnancyClosed: false,
    pregnancyServices: [],
    pregnancyHistory:[],
    throughParentProfile: false,
    throughReferralModule: false,
    childKYCDetails: {},
    childBalAbha: '',
    serviceExists: false,
    pageMenuFromLifeCalendar: null,
    childConsentIds: [],
    isChildRegistration: false,
    childRegistrationId: {},
    isKYCVerified: false,
    isKYCLoading: false,
    imageUrl:'',
    beneficiaryUpdateDetails: {},
    beneficiaryPregnancyHistory:{},
    pregnancyDetails:{},
    hrpStatus:{},
    beneficiaryImage:{},
    childBenefList:[],
    pageForPreviousPregnancyFromLifeCalendar: false,
    isFaceAuthenticated: false,
    beneficiaryObstetricHistory: null
};

const beneficiaryReducer = (
    state = initialState,
    action: beneficiaryActionType,
): BeneficiaryState => {
    switch (action.type) {
        case SET_BENEFICIARY_GENDER:
            return { ...state, beneficiaryGender: action.payload };
        case SET_BENEFICIARY_REDG_OPTION:
            return { ...state, beneficiaryRedgeOption: action.payload };
        case SET_BENEFICIARY_AUTH_TYPE:
            return { ...state, beneficiaryAuthType: action.payload };
        case SET_BENEFICIARY_MOBILE_NUMBER:
            return { ...state, beneficiaryMobileNumber: action.payload };
        case SET_TSNID:
            return { ...state, tsnId: action.payload };
        case SET_TXNID_FOR_ABHA_ADDRESS:
            return { ...state, txnIdForAbhaAddress: action.payload };
        case SET_ABHA_ADDRESS:
            return { ...state, abhaAddress: action.payload };
        case SET_PRIMARY_NO_FOR_RCH:
            return { ...state, primaryNoForRCH: action.payload };
        case SET_AADHAR:
            return { ...state, aadhar: action.payload };
        case SET_BENEFICIARY_ALREADY_IN_RCH:
            return { ...state, beneficiaryAlreadyInRCH: action.payload };
        case SET_BENEFICIARIES_IN_RCH:
            return { ...state, beneficiariesInRCH: action.payload };
        case SET_BENEFICIARY_DATA:
            return { ...state, beneficiaryData: action.payload };
        case SET_BENEFICIARY_DETAILS:
            return { ...state, beneficiaryDetails: action.payload };
        case SET_BENEFICIARY_ABHA:
            return { ...state, abha: action.payload };
        case UPDATE_CHILD:
            return {
                ...state, [action.payload.field]:
                    action.payload.value,
            };
        case SET_IMAGE_DATA:
            return { ...state, imageData: action.payload };
        case SET_IMAGE_EDITED:
            return { ...state, isImageEdited: action.payload };
        case SET_SHOW_CLOSE_MODAL:
            return { ...state, showCloseModal: action.payload };
        case SET_IS_BENEFICIARY_MODIFIED:
            return { ...state, isBeneficiaryModified: action.payload };
        case SET_ANC_NUMBER:
            return { ...state, ancNumber: action.payload };
        case SET_PREGNANCY_ID:
            return { ...state, pregnancyId: action.payload };
        case SET_PREGNANCY_HISTORY:
                return { ...state, pregnancyHistory: action.payload };   
        case SET_LMP_DATE:
            return { ...state, lmpDate: action.payload };
        case SET_DIFF_IN_WEEKS:
            return { ...state, diffInWeeks: action.payload };
        case SET_IS_VIEW_BUTTON_CLICKED:
            return { ...state, isViewButtonClicked: action.payload };
        case SET_IS_HRP:
            return { ...state, isHRP: action.payload };    
        case SET_CHECK_IS_HRP:
            return { ...state, checkIsHRP: action.payload };
        case SET_ANC_VISIT_DATE:
            return { ...state, ancVisitDate: action.payload };
        case SET_SHOW_PREGNANCY:
            return { ...state, showPregnancy: action.payload };
        case SET_IS_PREGNANT:
            return { ...state, isPregnant: action.payload };
        case SET_BENF_DEATH_DETAILS:
            return { ...state, benfDeathDetails: action.payload };
        case SET_SHOW_SERVICES:
            return { ...state, showServices: action.payload };
        case SET_SHOW_PREGNANCY_ONGOING:
            return { ...state, pregnancyOngoing: action.payload };    
        case SET_FACILITY_DETAILS:
            return { ...state, facilityDetails: action.payload };
        case UPDATE_ANCSERVICE:
            return {
                ...state, [action.payload.field]:
                    action.payload.value,
            };
        case UPDATE_PREG_HANDLER:
            return { ...state, ancPregnancyBackhandler: action.payload };
        case UPDATE_FAMILY_PLANNING_BACK_HANDLER:
            return { ...state, familyPlanningBackHandler: action.payload };
        case SET_FAMILY_PLANNING_DETAILS:
            return { ...state, familyPlanningDetails: action.payload };
        case UPDATE_FACILITY_SERVICE_DATA:
            return { ...state, facilityServiceData: action.payload }; 
        case VERIFY_CHILD_FROM_GRID:
            return { ...state, childVerifyFromGrid: action.payload };         
        case SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID:
            return { ...state, familyPlanningDetailsByTransactionId: action.payload };
        case SET_IS_FIRST_PREGNANCY:
            return { ...state, isFirstPregnancy: action.payload };    
        case UPDATE_DELIVERY_DETAILS:
            return {
                ...state, [action?.payload?.field]:
                    action?.payload?.value,
            };
        case UPDATE_PNC:
            return {
                ...state, [action?.payload?.field]:
                    action?.payload?.value,
            };
        case SET_CONSENT_LANGUAGE:
            return { ...state, consentLanguageID: action.payload };
        case UPDATE_FACILITY_META_DATA: 
            return {...state, facilityReferralMetaData: action.payload};
        case UPDATE_CHILD_DETAILS: 
            return {...state, childDetails: action.payload};
        case SET_REFERRAL_MODULE:
            return {
                ...state, [action.payload.field]:
                    action.payload.value,
            };
        case SET_LIFE_CALENDAR_PAGE_MENU:
            return { ...state, pageMenuFromLifeCalendar: action.payload };
        case SET_BENEFICIARY_PREGNANCY_HISTORY:
            return { ...state, beneficiaryPregnancyHistory: action.payload };
        case SET_PREGNANCY_DETAILS:
            return { ...state, pregnancyDetails: action.payload };
        case SET_HRP_STATUS:
            return { ...state, hrpStatus: action.payload };
        case SET_BENEFICIARY_IMAGE:
            return { ...state, beneficiaryImage: action.payload };
        case SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY:
            return { ...state, pageForPreviousPregnancyFromLifeCalendar: action.payload };
        case SET_CHILD_BENEF_LIST:
            return {
                ...state,
                childBenefList: Array.isArray(action.payload) ? action.payload : [],
              };
        case SET_BENEFICIARY_OBSTETRIC_HISTORY:
        return { ...state, beneficiaryObstetricHistory: action.payload };
        
        default:
            return state;
    }
};

export default beneficiaryReducer;